import {
  Box,
  Button,
  Modal,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Select,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";
import { LabelModeless } from "../LabelModeless";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  KeyModalPosState,
  labelModalPosState,
  ngCountState,
  openKeyModalState,
  projectImagesInfoState,
  selectedImageState,
} from "../../recoil";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  editImageLabel,
  editProjectConfig,
  getProject,
} from "../../services/projectService";
import { t } from "i18next";
import KeyMapping from "../KeyMapping";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { imageFlat } from "../../utils/utils";
import {
  IResponseProjectData,
  FilterSettings,
  IProjectData,
  IImageInfo,
} from "@types";
import { useGetProjects } from "../../hooks/useGetProjects";
import Keyboard from "react-simple-keyboard";
import "../setting/keyboard.css";
import {
  keyboardDisplay,
  keyboardLayout,
  commonKeyData,
} from "../../keyMapData/keyData";
import {} from "../../keyMapData/keyData";
import { getUserInfo } from "../../services/userService";
import { updateUserConfig } from "../../services/userService";
import ContourCanvas from "../ContourCanvas";
import { getPathImage } from "common-lib";
// import dummyImage from "../../assets/image.jpg";

interface ImageFilterProps {
  projectData: IResponseProjectData;
  filterStatus: boolean;
  filterSetting: FilterSettings;
  projectConfig: any;
  userConfig: any;
  setProjectConfig: (config: any) => void;
  setUserConfig: (config: any) => void;
  setIsClassKey: (isClassKey: boolean) => void;
  setIsKeyUndefined: (isKeyUndefined: boolean) => void;
  setIsKeySettingModal: (isKeySetting: boolean) => void;
  isKeySettingModal: boolean;
  setIsTrainable: (isTrainable: boolean) => void;
}

interface UserInfo {
  id: number;
}

interface UserConfig {
  keyMap: string[];
  controlKey?: string[];
  etcKey?: string[];
}

declare global {
  interface Window {
    onOpenCvReady?: () => void;
    cv: any;
  }
}

export default function ProjectImageContainer({
  projectData,
  filterStatus,
  filterSetting,
  projectConfig,
  userConfig,
  setUserConfig,
  setProjectConfig,
  setIsClassKey,
  setIsKeyUndefined,
  setIsKeySettingModal,
  isKeySettingModal,
  setIsTrainable,
}: ImageFilterProps) {
  const { id, label } = useParams();
  const [userId, setUserid] = useState<UserInfo>();
  const [labelModalPos, setLabelModalPos] = useRecoilState(labelModalPosState);
  const [keyModalPos, setKeyModalPos] = useRecoilState(KeyModalPosState);
  const containerRef = useRef<HTMLDivElement>(null);
  type ImageData = string | null;
  const [imageData, setImageData] = useState<ImageData>(null);
  const [selectedRow, setSelectedRow] = useRecoilState(selectedImageState);
  const [projectImagesInfo, setProjectImagesInfo] = useRecoilState(
    projectImagesInfoState,
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [labelList, setLabelList] = useState<string[]>([]);
  const [keyMappings, setKeyMappings] = useState<{ [key: string]: string }>({});
  const [listeningKey, setListeningKey] = useState<string | null>(null);
  const [openKeyModal, setOpenKeyModal] = useRecoilState(openKeyModalState);
  const forbiddenKeys = ["TAB", "CAPSLOCK", "ENTER", "F1"];
  const [ngCount, setNgCount] = useRecoilState(ngCountState);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [isOpenCVLoaded, setIsOpenCVLoaded] = useState(true);
  const [projectKeyMapping, setProjectKeyMapping] = useState<{
    [key: string]: string;
  }>({});
  const [prevProjectKeyMapping, setPrevProjectKeyMapping] = useState<{
    [key: string]: string;
  }>({});
  const [getAnotherProjectKeyMapping, setGetAnotherProjectKeyMapping] =
    useState<{
      [key: string]: string;
    }>({});
  const [isAllClear, setIsAllClear] = useState(false);
  const [isMoreButton, setIsMoreButton] = useState(false);
  const { projectsData } = useGetProjects();
  const [getProjectKeyMapping, setGetProjectKeyMapping] = useState(false);
  const [projectsDataOfStep, setProjectsDataOfStep] = useState<IProjectData[]>(
    [],
  );
  const [isKeyMappingApplied, setIsKeyMappingApplied] =
    useState<boolean>(false); // User Config 저장시 트리거
  const [step, setStep] = useState<string>("");
  const [validKeys, setValidKeys] = useState<string[]>([]);
  const [selectedProjectConfig, setSelectedProjectConfig] =
    useState<string>("");
  const [configType, setConfigType] = useState<string>("UserConfig");
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [saveUserConfig, setSaveUserConfig] = useState(false);
  const allKeys = commonKeyData.allKeys;
  const validClassKey = commonKeyData.validClassKey;
  const [isKeyHandling, setIsKeyHandling] = useState(false);
  const [isKeySetting, setIsKeySetting] = useState(false);
  const isKeySettingModalRef = useRef(isKeySettingModal);

  // clean up
  useEffect(() => {
    return () => {
      setImageData(null);
      setSelectedRow({} as IImageInfo);
    };
  }, []);

  useEffect(() => {
    labelList.forEach((label, index) => {
      setProjectKeyMapping((prev) => ({
        ...prev,
        [label]: projectConfig[index],
      }));
      setPrevProjectKeyMapping((prev) => ({
        ...prev,
        [label]: projectConfig[index],
      }));
    });
  }, [projectConfig]);

  useEffect(() => {
    if (saveUserConfig) {
      setGetAnotherProjectKeyMapping(userConfig.keyMap);
    }
    setSaveUserConfig(false);
  }, [saveUserConfig]);

  // 프로젝트 config 추출
  useEffect(() => {
    const fetchProjectData = async () => {
      if (!projectData || !projectData.config) return;
      let newKeyMapping: { [key: string]: string } = {};
      labelList.forEach((label, index) => {
        newKeyMapping[label] = projectData.config![index];
      });
      for (const [key, value] of Object.entries(newKeyMapping)) {
        if (value === undefined) {
          setIsKeyUndefined(true);
          break;
        }
      }
      setProjectKeyMapping(newKeyMapping);
    };
    fetchProjectData();
    setIsKeyMappingApplied(false);
  }, [id, isKeyMappingApplied]);

  useEffect(() => {
    if (window.cv) {
      setIsOpenCVLoaded(true);
    } else {
      window.onOpenCvReady = () => {
        setIsOpenCVLoaded(true);
      };
    }
  }, []);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    setUserid(userInfo.id);
  }, []);

  useEffect(() => {
    setStep(projectData.step);
    setValidKeys(allKeys);
    const loadInitialImageData = async () => {
      try {
        if (id) {
          if (projectData) {
            const imagesData = projectData.images;
            const imagesFlatData = imageFlat(imagesData);
            setLabelList(projectData.class);
            // setNgCount(
            //   imagesFlatData.filter((image) => image.label === "NG").length
            // );
            setNgCount(projectData.NGCount);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    loadInitialImageData();
  }, []);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const loadAndApplyFilter = async () => {
      if (!selectedRow.path) return;

      setIsLoading(true);
      try {
        // 1. 이미지 데이터 로드
        const response = await getPathImage(selectedRow.path);
        setImageData(response);

        // 2. 이미지 처리 및 필터 적용
        const img = new Image();
        img.onload = async () => {
          if (!canvasRef.current) return;

          // 캔버스 크기 설정
          canvasRef.current.width = 770;
          canvasRef.current.height = 812;

          if (filterStatus && isOpenCVLoaded) {
            // 필터가 켜져있고 OpenCV가 로드된 경우
            await applyOpenCVFilter(img);
          } else {
            // 필터가 꺼져있거나 OpenCV가 로드되지 않은 경우
            const context = canvasRef.current.getContext("2d");
            if (context) {
              context.clearRect(
                0,
                0,
                canvasRef.current.width,
                canvasRef.current.height,
              );
              context.drawImage(
                img,
                0,
                0,
                canvasRef.current.width,
                canvasRef.current.height,
              );
            }
          }
        };
        img.src = response;
      } catch (error) {
        console.error("이미지 로드/필터 적용 중 오류:", error);
      } finally {
        setIsLoading(false);
      }
    };
    timeoutId = setTimeout(() => {
      loadAndApplyFilter();
    }, 200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [selectedRow, filterStatus, filterSetting, isOpenCVLoaded]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [keyMappings, selectedRow, projectKeyMapping, isKeyHandling]);

  useEffect(() => {
    isKeySettingModalRef.current = isKeySettingModal;
  }, [isKeySettingModal]);

  const applyOpenCVFilter = async (imageElement: HTMLImageElement) => {
    if (!isOpenCVLoaded || !filterSetting.opencvFilter) return;

    try {
      const cv = window.cv instanceof Promise ? await window.cv : window.cv;
      const src = cv.imread(imageElement);
      let dst = src.clone();

      // 색공간 변환 처리
      const colorSpace = filterSetting.opencvFilter?.cvtcolor?.colorSpace;
      if (colorSpace && colorSpace !== "") {
        console.log("Applying color space conversion:", colorSpace); // 디버깅용
        const converted = new cv.Mat();
        try {
          // 색공간 변환 상수 매핑
          const colorSpaceMap: { [key: string]: number } = {
            GRAY: cv.COLOR_RGBA2GRAY,
            HSV: cv.COLOR_RGB2HSV,
            LAB: cv.COLOR_RGB2Lab,
            BGR: cv.COLOR_RGB2BGR,
            XYZ: cv.COLOR_RGB2XYZ,
            YCrCb: cv.COLOR_RGB2YCrCb,
            HLS: cv.COLOR_RGB2HLS,
            LUV: cv.COLOR_RGB2Luv,
            YUV: cv.COLOR_RGB2YUV,
          };

          const targetColorSpace = colorSpaceMap[colorSpace];
          if (targetColorSpace) {
            cv.cvtColor(dst, converted, targetColorSpace);
            // GRAY의 경우 다시 RGBA로 변환
            if (colorSpace === "GRAY") {
              cv.cvtColor(converted, dst, cv.COLOR_GRAY2RGBA);
            } else {
              // 다른 색공간의 경우 원래 채널 수를 유지하면서 변환
              const channels = converted.channels();
              if (channels === 1) {
                cv.cvtColor(converted, dst, cv.COLOR_GRAY2RGBA);
              } else if (channels === 3) {
                cv.cvtColor(converted, dst, cv.COLOR_RGB2RGBA);
              } else {
                converted.copyTo(dst);
              }
            }
          }
        } finally {
          converted.delete();
        }
      }

      // equalizehist 처리
      const equalizeStrength =
        filterSetting.opencvFilter?.equalizehist?.strength ?? 0;
      if (equalizeStrength > 0) {
        console.log("Applying equalizehist with strength:", equalizeStrength); // 디버깅용
        const gray = new cv.Mat();
        const equalizedGray = new cv.Mat();
        try {
          // RGBA to GRAY 변환
          cv.cvtColor(dst, gray, cv.COLOR_RGBA2GRAY);
          // 히스토그램 평활화 적용
          cv.equalizeHist(gray, equalizedGray);
          // 원본과 평활화된 이미지를 블렌딩
          const alpha = equalizeStrength / 100;
          cv.addWeighted(gray, 1 - alpha, equalizedGray, alpha, 0, gray);
          // GRAY to RGBA 변환
          cv.cvtColor(gray, dst, cv.COLOR_GRAY2RGBA);
        } finally {
          gray.delete();
          equalizedGray.delete();
        }
      }

      // laplacian 처리
      const laplacianStrength =
        filterSetting.opencvFilter?.laplacian?.strength ?? 0;
      if (laplacianStrength > 0) {
        console.log("Applying laplacian with strength:", laplacianStrength); // 디버깅용
        const gray = new cv.Mat();
        const edges = new cv.Mat();
        try {
          // RGBA to GRAY 변환
          cv.cvtColor(dst, gray, cv.COLOR_RGBA2GRAY);
          // Laplacian 필터 적용
          cv.Laplacian(gray, edges, cv.CV_8U, 3, 1, 0, cv.BORDER_DEFAULT);
          // 원본과 엣지를 블렌딩
          cv.addWeighted(
            gray,
            1 - laplacianStrength / 100,
            edges,
            laplacianStrength / 100,
            0,
            gray,
          );
          // GRAY to RGBA 변환
          cv.cvtColor(gray, dst, cv.COLOR_GRAY2RGBA);
        } finally {
          gray.delete();
          edges.delete();
        }
      }

      // 결과 표시
      if (canvasRef.current) {
        cv.imshow(canvasRef.current, dst);
      }

      // 메모리 정리
      src.delete();
      dst.delete();
    } catch (error) {
      console.error("OpenCV 필터 적용 중 오류 발생:", error);
      console.log("에러 상세:", error);
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (
      isKeyHandling ||
      isKeySettingModalRef.current ||
      event.key === "Process"
    )
      return;
    setIsKeyHandling(true);
    // 이미 매핑된 키가 없으면 무시
    if (!projectKeyMapping || Object.keys(projectKeyMapping).length === 0) {
      return;
    }

    const key = event.key.toUpperCase();

    // 금지된 키는 무시
    if (forbiddenKeys.includes(key)) {
      setIsKeyHandling(false);
      return;
    }

    // 매핑된 키인지 확인
    const label = Object.keys(projectKeyMapping).find(
      (mappedLabel) => projectKeyMapping[mappedLabel] === key,
    );

    if (label) {
      event.preventDefault();
      // 매핑된 키에 따른 동작 실행
      if (label === "OK") {
        handleOKLabelClick();
      } else if (label === "NG") {
        handleNGLabelClick();
      } else {
        handleLabelingClick(undefined, label);
      }
    }
    setTimeout(() => {
      setIsKeyHandling(false);
    }, 200);
  };

  // 조작키 설정
  const handleKeyMappingChange = (label: string, key: string) => {
    const isDuplicate = Object.entries(projectKeyMapping).some(
      ([existingLabel, existingKey]) =>
        existingKey === key && existingLabel !== label,
    );

    if (isDuplicate) {
      toast.warning(`입력하신 키는 이미 다른 키에 할당되어 있습니다.`);
      return;
    }

    setProjectKeyMapping((prev) => ({
      ...prev,
      [label]: key,
    }));
    setIsAllClear(true);
  };

  // OK 라벨링 버튼
  const handleOKLabelClick = async (e: any = undefined) => {
    const start = new Date();
    let ngCheck = ngCount;

    if (id && projectData.step !== "검사") {
      try {
        await editImageLabel(Number(id), selectedRow.path!, "OK");

        if (selectedRow.label === "NG") {
          setNgCount((prev) => prev - 1);
          ngCheck -= 1;
        }

        setProjectImagesInfo((prevImages) => {
          const updatedImages = prevImages.map((image) =>
            image.seq === selectedRow.seq ? { ...image, label: "OK" } : image,
          );
          return updatedImages;
        });
        const nextRow = (selectedRow.seq ?? 0) + 1;
        const hasMore = projectImagesInfo.find(
          (image) => image.seq === nextRow,
        );
        // setSelectedRowId(nextRow); // 추가
        if (!hasMore) {
          toast.warning("마지막 이미지입니다.");
          return;
        }
        if (nextRow < projectImagesInfo.length) {
          setSelectedRow(projectImagesInfo[nextRow]);
          setIsClassKey(true);
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (ngCheck < 11) {
          setIsTrainable(false);
        }
      }
    }
    if (e) {
      e.target.blur();
    }
    const end = new Date();
    const elapsedTime = end.getTime() - start.getTime();
    console.log(`OK 라벨링 소요 시간: ${elapsedTime}ms`);
  };

  // NG 라벨링 버튼
  const handleNGLabelClick = async (e: any = undefined) => {
    let ngCheck = ngCount;
    if (e) {
      e.target.blur();
    }
    if (id && projectData.step !== "검사") {
      try {
        await editImageLabel(Number(id), selectedRow.path!, "NG");
        if (selectedRow.label === "OK" || selectedRow.label === "") {
          setNgCount((prev) => prev + 1);
          ngCheck += 1;
        }
      } catch (error) {
        console.error(error);
      } finally {
        setProjectImagesInfo((prevImages) =>
          prevImages.map((image) =>
            image.seq === selectedRow.seq ? { ...image, label: "NG" } : image,
          ),
        );
        if (ngCheck > 10) {
          // toast.warning(
          //   `NG데이터가 10장 이상으로 학습 가능합니다. 현재 NG 데이터: ${ngCount}장`
          // );
          setIsTrainable(true);
        }
        const nextRow = (selectedRow.seq ?? 0) + 1;
        if (nextRow < projectImagesInfo.length) {
          setSelectedRow(projectImagesInfo[nextRow]);
          setIsClassKey(true);
        }
      }
    }
  };

  // 라벨링 버튼
  const handleLabelingClick = async (e: any = undefined, label: string) => {
    setValidKeys(validClassKey);
    if (e) {
      e.target.blur();
    }
    try {
      const response = await editImageLabel(
        Number(id),
        selectedRow.path!,
        label,
      );
    } catch (error) {
      console.error(error);
    } finally {
      setProjectImagesInfo((prevImages) =>
        prevImages.map((image) =>
          image.path === selectedRow.path ? { ...image, label: label } : image,
        ),
      );
      const currentIndex = projectImagesInfo.findIndex(
        (row) => row.id === selectedRow?.id,
      );
      if (currentIndex >= 0 && currentIndex < projectImagesInfo.length - 1) {
        setSelectedRow(projectImagesInfo[currentIndex + 1]);
      }
    }
  };

  // 키맵핑 초기화
  const handleAllClear = () => {
    setProjectKeyMapping(prevProjectKeyMapping);
    setIsAllClear(false);
  };

  const buildFilterStyle = (filterSetting: FilterSettings): string => {
    const { brightness, contrast, saturate, blur } = filterSetting;

    const cssBrightness = brightness ? (brightness + 100) / 100 : 1;
    const cssContrast = contrast ? (contrast + 100) / 100 : 1;
    const cssSaturate = saturate ? (saturate + 100) / 100 : 1;

    return `
      ${brightness ? `brightness(${cssBrightness})` : ""}
      ${contrast ? `contrast(${cssContrast})` : ""}
      ${saturate ? `saturate(${cssSaturate})` : ""}
      ${blur ? `blur(${blur}px)` : ""}
    `.trim();
  };

  // OpenCV 필터 사용 여부 체크 함수
  const hasOpenCVFilters = () => {
    if (!filterSetting.opencvFilter) return false;

    return Object.values(filterSetting.opencvFilter).some((filter) => {
      if (!filter) return false;
      return Object.values(filter).some((value) => value !== 0 && value !== "");
    });
  };

  // 키 모달 닫기
  const modalClose = () => {
    setProjectKeyMapping(prevProjectKeyMapping);
    setOpenKeyModal(false);
    setIsAllClear(false);
    setIsMoreButton(false);
    setIsKeySettingModal(false);
  };

  // 더보기 버튼
  const handleMoreButton = (prev: boolean) => {
    setIsMoreButton(prev);
  };

  // 프로젝트 키 맵핑 가져오기
  const handleGetProjectKeyMapping = () => {
    setGetProjectKeyMapping(true);
    const projectsDataOfStep = projectsData.data.filter(
      (project) => project.step === step && project.id !== Number(id),
    );

    // 가져오기 클릭시 configType이 UserConfig일 경우 userConfig.keyMap를 가져오기
    if (configType === "UserConfig") {
      setGetAnotherProjectKeyMapping(userConfig.keyMap);
    }
    setSelectedProjectConfig(projectsDataOfStep[0].config);
    setProjectsDataOfStep(projectsDataOfStep);
  };

  // UserConfig에 저장
  const handleSaveUserConfig = async () => {
    const updatedUserConfig = {
      ...userConfig,
      keyMap: Object.values(projectKeyMapping).map((mapping) => {
        return Object.values(mapping)[0];
      }),
    };
    try {
      await updateUserConfig(updatedUserConfig as UserConfig, Number(userId));

      const updatedUserInfo = await getUserInfo(Number(userId));
      const userInfoForStorage = {
        ...updatedUserInfo.user,
        config: JSON.stringify(updatedUserInfo.user.config),
      };
      // localStorage 업데이트
      localStorage.setItem("userInfo", JSON.stringify(userInfoForStorage));
      setUserid(updatedUserInfo.user.id);
      setUserConfig(updatedUserInfo.user.config);
      setSaveUserConfig(true);
      toast.success(t("SuccessSaveMsg"));
    } catch (error) {
      console.error("Error updating user config:", error);
      toast.error(t("InternalServerError"));
    }
  };

  // 프로젝트 키 맵핑 저장
  const handleSaveProjectConfig = async () => {
    if (
      JSON.stringify(prevProjectKeyMapping) ===
      JSON.stringify(projectKeyMapping)
    ) {
      toast.info(t("NoChangesMsg"));
      return;
    }
    if (Object.values(projectKeyMapping).some((value) => value === undefined)) {
      toast.warning("설정되지 않은 키가 있습니다. 모든 키를 설정해주세요.");
      return;
    }
    const updatedKeyMapping =
      Object.values(projectKeyMapping).map((mapping) => {
        return Object.values(mapping)[0]; // 키만 추출하여 배열로 반환
      }) || [];

    try {
      await editProjectConfig(Number(id), updatedKeyMapping);
      toast.success(t("SuccessSaveMsg"));
      setProjectConfig(updatedKeyMapping);
      // 객체 형태로 변환해서 바로 반영
      const updatedKeyMappingObj = labelList.reduce(
        (acc, label, idx) => {
          acc[label] = updatedKeyMapping[idx];
          return acc;
        },
        {} as { [key: string]: string },
      );
      setProjectKeyMapping(updatedKeyMappingObj);
      setOpenKeyModal(false);
      setIsKeySettingModal(false);
    } catch (error) {
      console.error("Error updating project config:", error);
      toast.error(t("InternalServerError"));
    }
  };

  const handleChangeProject = async (id: number) => {
    if (id === Number(id)) {
      const project = await getProject(Number(id));
      setGetAnotherProjectKeyMapping(project.project.config || {});
    } else {
      return;
    }
  };

  // 프로젝트 키 가져오기 저장
  const handleApplyGetProject = () => {
    if (Object.keys(getAnotherProjectKeyMapping).length === 0) {
      toast.warning("가져올 프로젝트 키가 없습니다.");
      return;
    }
    const updatedConfig = Object.entries(projectKeyMapping).reduce<
      Record<string, string>
    >((acc, [label, currentKey], index) => {
      // getAnotherProjectKeyMapping의 값을 순서대로 가져오기
      acc[label] =
        Object.values(getAnotherProjectKeyMapping)[index] || currentKey;
      return acc;
    }, {});
    setGetProjectKeyMapping(false);
    setGetAnotherProjectKeyMapping({});
    setProjectKeyMapping(updatedConfig);
  };

  // 프로젝트 키 맵핑 타입 변경
  const handleConfigTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfigType(e.target.value);
    if (e.target.value === "UserConfig") {
      setGetAnotherProjectKeyMapping(userConfig.keyMap);
    } else {
      setGetAnotherProjectKeyMapping({});
    }
  };

  // UserConfig에 저장 확인 모달
  const handleConfirmSave = () => {
    handleSaveUserConfig();
    setOpenConfirmModal(false);
  };

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-block",
        // width: "fit-content",
        width: "770px",
        height: "100%",
      }}
      ref={containerRef}
    >
      {/* {imageData && (
        <ContourCanvas
          imageData={imageData}
          filterStatus={filterStatus}
          filterSetting={filterSetting}
        />
      )} */}
      {imageData && (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div style={{ width: "100%" }}>
            <img
              src={imageData}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 0,
                filter: filterStatus ? buildFilterStyle(filterSetting) : "none",
              }}
            />
            <canvas
              ref={canvasRef}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
                width: "100%",
                height: "100%",
                filter: buildFilterStyle(filterSetting),
              }}
            />
          </div>
        </div>
      )}
      <LabelModeless
        open={true}
        position={labelModalPos}
        setModalPos={setLabelModalPos}
        containerRef={containerRef}
        width={80 * labelList.length + 70}
        height={60}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {labelList.map((label, index) => (
            <Button
              key={index}
              variant="contained"
              sx={{
                backgroundColor: "var(--secondary-bg-color)",
                color: "var(--text-color)",
                "&:hover": {
                  backgroundColor: "lightgray",
                },
              }}
              onClick={(e) => handleLabelingClick(e, label)}
            >
              {label}:{" "}
              <span
                style={{
                  display: "inline-block",
                  padding: "2px 6px",
                  // backgroundColor: "#f0f0f0",
                  backgroundColor: "var(--main-bg-color)",
                  borderRadius: "3px",
                  // border: "1px solid #ddd",
                  boxShadow: "0 2px 0 var(--text-secondary-color)",
                  fontFamily: "monospace",
                  fontSize: "0.9em",
                  minWidth: "20px",
                  textAlign: "center",
                  position: "relative",
                  top: "-1px",
                  marginLeft: "5px",
                }}
              >
                {projectConfig[index]}
              </span>
            </Button>
          ))}
        </Box>
      </LabelModeless>
      <Modal open={openKeyModal} onClose={modalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "var(--label-modal-bg)",
            width: "60%", // 원하는 너비로 조정
            p: 4,
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: "30%", border: "1px solid lightgray" }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Label</TableCell>
                      <TableCell align="center">Key</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {labelList?.map((labelItem) => (
                      <TableRow key={labelItem}>
                        <TableCell align="center">{labelItem}</TableCell>
                        <TableCell align="center">
                          <KeyMapping
                            key={labelItem}
                            label={labelItem}
                            keyMapping={
                              projectKeyMapping[labelItem] || "Set Key"
                            }
                            onKeyChange={handleKeyMappingChange}
                            listeningKey={listeningKey}
                            setListeningKey={setListeningKey}
                            openKeyModal={openKeyModal}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            <Box
              sx={{
                width: "69%",
                border: "1px solid lightgray",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box sx={{ width: "90%", mt: 2 }}>
                <Keyboard
                  sx={{ point: "none" }}
                  layout={keyboardLayout}
                  display={keyboardDisplay}
                  theme="hg-theme-default myTheme"
                  buttonTheme={[
                    {
                      class: "highlight-key",
                      buttons: Object.values(projectKeyMapping).join(" ") || "",
                    },
                  ].filter((theme) => theme.buttons !== "")}
                />
              </Box>
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            {/* <Button onClick={() => handleMoreButton(!isMoreButton)}>
              ...더보기
            </Button> */}
            <Button variant="outlined" onClick={handleGetProjectKeyMapping}>
              가져오기
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpenConfirmModal(true)}
            >
              UserConfig에 저장
            </Button>
            <Button variant="outlined" onClick={handleAllClear}>
              {t("AllClear")}
            </Button>
            <Button
              variant="outlined"
              sx={{ mr: 1 }}
              onClick={handleSaveProjectConfig}
            >
              apply
            </Button>
            <Button
              onClick={() => {
                modalClose();
              }}
              variant="outlined"
            >
              {t("Close")}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={getProjectKeyMapping}
        onClose={() => {
          setGetProjectKeyMapping(false);
          setProjectKeyMapping(prevProjectKeyMapping);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "70%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "var(--label-modal-bg)",
            width: "60%", // 원하는 너비로 조정
            p: 4,
            borderRadius: 1,
          }}
        >
          <Typography sx={{ mb: 2, fontSize: "18px", fontWeight: "bold" }}>
            프로젝트 키 맵핑 가져오기
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              border: "1px solid lightgray",
              p: 1,
              borderRadius: 1,
            }}
          >
            <Box sx={{ width: "30%", ml: 1 }}>
              <RadioGroup value={configType} onChange={handleConfigTypeChange}>
                <FormControlLabel
                  value="UserConfig"
                  control={<Radio />}
                  label="UserConfig"
                />
                <FormControlLabel
                  value="ProjectConfig"
                  control={<Radio />}
                  label="ProjectConfig"
                />
              </RadioGroup>
            </Box>
            {configType === "ProjectConfig" ? (
              <Box
                sx={{
                  width: "70%",
                  height: "80px",
                  borderLeft: "1px solid lightgray",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Select
                  onChange={(e) => {
                    handleChangeProject(Number(e.target.value));
                  }}
                  defaultValue="choice"
                  sx={{
                    ml: 1,
                  }}
                >
                  <MenuItem value="choice">선택하세요</MenuItem>
                  {projectsDataOfStep.map((project) => (
                    <MenuItem key={project.id} value={project.id}>
                      {project?.project_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            ) : null}
          </Box>
          <Box
            sx={{
              mt: 2,
            }}
          >
            {}
            <Keyboard
              sx={{ point: "none" }}
              layout={keyboardLayout}
              display={keyboardDisplay}
              theme="hg-theme-default myTheme"
              buttonTheme={[
                {
                  class: "highlight-key",
                  buttons:
                    Object.values(getAnotherProjectKeyMapping).join(" ") || "",
                },
              ].filter((theme) => theme.buttons !== "")}
            />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="outlined"
              sx={{ mr: 1 }}
              onClick={handleApplyGetProject}
            >
              {t("Apply")}
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setGetProjectKeyMapping(false);
                setGetAnotherProjectKeyMapping({});
              }}
            >
              닫기
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openConfirmModal} onClose={() => setOpenConfirmModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "var(--label-modal-bg)",
            p: 4,
            borderRadius: 1,
            width: "400px",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            현재 설정된 키매핑을 UserConfig에 저장하시겠습니까?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={handleConfirmSave}>
              확인
            </Button>
            <Button
              variant="outlined"
              onClick={() => setOpenConfirmModal(false)}
            >
              취소
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
